import { myAxios } from "../../utils/serverContextPath";
import { useTranslation } from "react-i18next";
export const getActivityProfById = (id) => {
  return myAxios.get(`activityprof/getbyid/${id}`);
};

export const getActivityProfAllPage = (
  keyword = "",
  pageNumber = 0,
  itemsPerPage = 10,
  sortList = [],
  sortOrder = "DESC"
) => {

  
  return myAxios.get("activityprof/getallpage", {
    params: {
      keyword,
      page: pageNumber,
      size: itemsPerPage,
      sortList,
      sortOrder,
    },
  });
};

export const getAllActivityProf = (
  keyword = "",
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("activityprof/getall", {
    params: {
      keyword,
      sortList,
      sortOrder,
    },
  });
};

export const getByTypeActiviTypProfPage= (
  val = "",
  keyword = "",
  pageNumber = 0,
  itemsPerPage = 10,
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("activityprof/getbytypeactivityprofpage", {
    params: {
      val,
      keyword,
      page: pageNumber,
      size: itemsPerPage,
      sortList,
      sortOrder,
    },
  });
};

export const deleteActivityProf = (id) => {
  return myAxios.delete(`activityprof/delete/${id}`);
};

export const postActivityProf = (data) => {
  return myAxios.post("activityprof/save/insert", data);
};

export const updateActivityProf = (data) => {
  return myAxios.post("activityprof/save/Update", data);
};

export const findSimilarActivityProf = (
  keyword,
  tauxsimilarity = 0.8,
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("activityprof/similarity", {
    params: {
      keyword,
      tauxsimilarity,
      sortList,
      sortOrder,
    },
  });
};

//---------

export const getActivityProfByTypeActivityPro = (
  val = "",
  keyword = "",
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("activityprof/getbytypeactivityprof", {
    params: {
      val,
      keyword,
      sortList,
      sortOrder,
    },
  });
};

